module.exports = __webpack_public_path__ + "img/mortality.53c99332.svg";